import _unionWith from 'lodash/unionWith';
import _isEqual from 'lodash/isEqual';
import actionTypes from '../actions/actionTypes';
import { emailCompositionSteps } from '../utils/constants';

const INITIAL_STATE = {
  loading: false,
  error: null,
  allAssets: {
    data: [],
    nextCursor: null,
    totalCount: 0,
  },
  allScripts: {
    scripts: [],
    nextCursor: null,
  },
  messageCompositionScripts: {
    introduction: {
      scripts: [],
      nextCursor: null,
    },
    offer: {
      scripts: [],
      nextCursor: null,
    },
    why: {
      scripts: [],
      nextCursor: null,
    },
    nextSteps: {
      scripts: [],
      nextCursor: null,
    },
  },
  searchAssets: {
    data: [],
    nextCursor: null,
    totalCount: 0,
  },
};

const mapAssetsData = (data, payload) => ({
  data: _unionWith(data, payload?.resources, _isEqual),
  nextCursor: payload?.nextCursor || null,
  totalCount: payload?.totalCount,
});

export const mapMarketingScriptsSuccessPayload = (state, payload) => {
  if (!payload || (!payload.scripts && !payload.nextCursor)) return state;
  const { subFolder } = payload;
  let changedState;
  if (!subFolder) {
    changedState = {
      allScripts: {
        scripts: [...state.allScripts.scripts, ...payload.scripts],
        nextCursor: payload.nextCursor,
      },
    };
  } else {
    const scriptsStateKey = emailCompositionSteps.find(({ title }) => subFolder === title).id;
    changedState = {
      messageCompositionScripts: {
        ...state.messageCompositionScripts,
        [scriptsStateKey]: {
          scripts: [...state.messageCompositionScripts[scriptsStateKey].scripts, ...payload.scripts],
          nextCursor: payload.nextCursor,
        },
      },
    };
  }

  return {
    ...state,
    loading: false,
    ...changedState,
  };
};

const marketing = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.MARKETING_ASSETS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.MARKETING_ASSETS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.MARKETING_SCRIPTS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.MARKETING_SCRIPTS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.GET_MARKETING_SCRIPTS_SUCCESS:
      return mapMarketingScriptsSuccessPayload(state, payload);
    case actionTypes.GET_MARKETING_ASSETS_SUCCESS:
      return {
        ...state,
        loading: false,
        allAssets: mapAssetsData(state.allAssets.data, payload),
      };
    case actionTypes.SEARCH_MARKETING_ASSETS_SUCCESS:
      return {
        ...state,
        loading: false,
        searchAssets: mapAssetsData(state.searchAssets.data, payload),
      };
    case actionTypes.NEW_SEARCH_MARKETING_ASSETS_SUCCESS:
      return {
        ...state,
        loading: false,
        searchAssets: {
          data: payload?.resources || [],
          nextCursor: payload?.nextCursor || null,
          totalCount: payload?.totalCount,
        },
      };
    case actionTypes.RESET_MARKETING_ASSETS:
      return {
        ...state,
        loading: false,
        error: null,
        allAssets: {
          data: [],
          nextCursor: null,
          totalCount: 0,
        },
      };
    case actionTypes.RESET_SEARCH_MARKETING_ASSETS:
      return {
        ...state,
        loading: false,
        error: null,
        searchAssets: {
          data: [],
          nextCursor: null,
          totalCount: 0,
        },
      };
    default:
      return state;
  }
};

export default marketing;
